<template>
  <div class="dep-edit">
    <page-title>
      {{ $t('orgs.edit_org') }}:
      <router-link v-if="org" :to="{  name: 'orgPage', params: { id: id } }">
        {{org.getName()}}
      </router-link>
    </page-title>
    <el-tabs v-model="activeTab">
      <el-tab-pane :label="$t('orgs.data_org')" name="first">
        <edit-data v-if="org"
                   :org="org"
                   @updateData="orgUpdate"
                   @error="onError"></edit-data>
      </el-tab-pane>
      <el-tab-pane :label="$t('orgs.info_org')" name="third">
        <edit-info v-if="org"
                   :org="org"
                   @updateData="orgUpdate"
                   @error="onError"></edit-info>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import pageTitle from 'src/components/PageTitle/pageTitle.vue'
  import editData from 'src/components/Orgs/OrgEdit/data.vue'
  import editInfo from 'src/components/Orgs/OrgEdit/info.vue'

  export default {
    name: 'OrgEdit',
    props: ['id'],
    components: {
      pageTitle,
      editData,
      editInfo
    },
    data () {
      return {
        activeTab: 'first',
        loaded: false
      }
    },
    computed: {
      org () {
        return this.$store.state.orgs.orgs[this.id]
      }
    },
    methods: {
      async getOrg (id) {
        await this.$store.dispatch('orgs/loadOrg', this.id)
      },
      orgUpdate () {
        this.loaded = false;
        this.getOrg(this.id)
        this.$notify({
          title: this.$t('labels.data_updated'),
          type: 'success',
          offset: 75
        })
      },
      onError () {
        this.$notify({
          title: this.$t('labels.can_not_update_data'),
          type: 'error',
          offset: 75
        })
      }
    },
    async mounted () {
      await this.getOrg(this.id)
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';
.dep-edit {
  .el-tabs {
    &__nav-wrap {
      padding: 0 30px;
      background: #fff;
      border-radius: $global-radius;
      box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.05);

      &:after {
        display: none;
      }
    }

    &__content {
      overflow: visible;
    }

    &__item {
      font-weight: 400;
      color: $secondary-font-color;

      &.is-active {
        color: #1989FA;
      }
    }

    &__active-bar {
      height: 3px;
      background-color: #1989FA;
    }
  }
}
</style>